import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { updatePropertyEndpoint } from '../services/propertyService';
import { UpdatePropertyOperation } from '../models/propertyModel';

interface UpdateResult {
  status: number;
  error?: any;
  request?: UpdatePropertyOperation;
  response?: any;
}

const useUpdatePropertyOperationView = () => {
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const { callEndpoint } = useCallApiAndLoad();
  const [loading, setLoading] = useState(false);

  const updateProperty = async (
    propertyId: string,
    fields: UpdatePropertyOperation
  ): Promise<UpdateResult> => {
    setLoading(true);
    try {
      const { status, data } = await callEndpoint(
        updatePropertyEndpoint(fields, propertyId, token)
      );
      setLoading(false);
      return {
        status,
        error: status !== 200 ? data : undefined,
        request: fields,
        response: data,
      };
    } catch (error) {
      setLoading(false);
      return {
        status: 500,
        error,
        request: fields,
        response: undefined,
      };
    }
  };

  return {
    updateProperty,
    loading,
  };
};

export default useUpdatePropertyOperationView;